import { FormStateType } from "../../../../types";
import { BUSINESS_DETAILS_CONSTANTS } from "../../../constants";

export const formFieldsState: FormStateType = {
  [BUSINESS_DETAILS_CONSTANTS.BUSINESS_UNIT]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.VERTICAL]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_NAME]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_NAME]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.POINT_OF_CONTACT_EMAIL_ADDRESS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESSES]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESS_0]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.ADDITIONAL_CONTACT_EMAIL_ADDRESS_1]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_LINE_1]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_LINE_2]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_CITY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_STATE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.COMPANY_ADDRESS_ZIP_CODE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [BUSINESS_DETAILS_CONSTANTS.COUNTRY_ID]: {
    value: "",
    errors: [],
    hidden: false,
  },
};
